import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { ServicePlanTermFormSchemaValues } from 'src/features/servicePlanTerms/utils/formSchema';
import { ServicePlanTerm } from 'src/features/servicePlanTerms/utils/types';

const RESOURCE = '/subscriptions/service-plan/:servicePlanId/service-plan-terms/';

type MutationFnType = typeof mutationFn;

interface DTO extends ServicePlanTermFormSchemaValues {
    servicePlanId: string;
}

const mutationFn = ({ servicePlanId, ...data }: DTO): Promise<ServicePlanTerm> => {
    return axios.post(formatResourcePath(RESOURCE, { servicePlanId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateServicePlanTerm };
